// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ApplyCreditsToggle_toggle__2lidj"};